import i18n from 'locales/i18next';

import { getShortenedCryptoCurrencyCode } from 'utils/currencies';
import { formatNumberI18n } from 'utils/i18n';

export const formatNumber = (stringOrNumber?: string | number | null) => formatNumberI18n(i18n.language)(Number(stringOrNumber ?? 0));
export const formatCryptoCode = (code?: string | null) => getShortenedCryptoCurrencyCode(code);
